<figure class="wrapper">
  <div class="icon-wrapper">
    <div 
      class="icon-wrapper__animation"
      bulbAnimations
      [elementAnimations]="animationNames?.background"
      [animationTrigger]="likeCount">
    </div>
    <div 
      class="icon-wrapper__animation"
      bulbAnimations
      [elementAnimations]="animationNames?.secondaryBackground"
      [animationTrigger]="likeCount">
    </div>
      <svg-icon 
      class="icon-wrapper__icon icon-wrapper__icon--display"
      fontSize="1.1em"
      [ngClass]="{
        'icon-wrapper__icon--fill-red': likeCount > 0 && likedByUser,
        'icon-wrapper__icon--fill-gray': likeCount > 0 && !likedByUser}"
      [key]="iconKey"
      bulbAnimations
      [elementAnimations]="animationNames?.icon"
      [animationTrigger]="likeCount">
    </svg-icon>
  </div>
  <figcaption 
    bulbAnimations
    [elementAnimations]="animationNames?.text"
    [animationTrigger]="likeCount"
    class="wrapper__label">
      {{likeCount}}
  </figcaption>
  <figcaption class="wrapper__label">{{textTranslation}}</figcaption>
</figure>
